module.exports = __webpack_public_path__ + "static/media/cartas.cabf1356.svg";